export default __webpack_public_path__ + "static/media/favicon.7f477759.svg";